import match from './AutocompleteMatch';
import parse from 'autosuggest-highlight/parse';

export interface IPart {
  text: string;
  highlight: boolean;
}
/**
 * Splits text to parts that matches query, marks matching parts with highlighted=true.
 * @param text String to search from
 * @param query The string to match
 */
export const getTextParts = (text: string, query: string): IPart[] => {
  const matches = match(text, query);
  return parse(text, matches);
};
